import Toggle from "../../../controls/Toggle";
import { ComponentEx, connect, translate } from "../../../controls/ComponentEx";
import { getSafe } from "../../../util/storeHelper";
import { setDashletEnabled } from "../actions";
import * as React from "react";
import { ControlLabel, FormGroup, HelpBlock } from "react-bootstrap";
class DashletToggle extends React.PureComponent {
    render() {
        const { t, dashlet, enabled } = this.props;
        return (React.createElement(Toggle, { checked: enabled, onToggle: this.toggle }, t(dashlet.title)));
    }
    toggle = (newValue) => {
        const { dashlet, onToggle } = this.props;
        onToggle(dashlet.title, newValue);
    };
}
class Settings extends ComponentEx {
    render() {
        const { t, dashlets, dashletSettings, onSetDashletEnabled } = this.props;
        return (React.createElement("form", null,
            React.createElement(FormGroup, { controlId: "dashlets" },
                React.createElement(ControlLabel, null, t("Dashlets")),
                React.createElement(HelpBlock, null, t("Enable Dashboard Widgets")),
                dashlets
                    .filter((dashlet) => dashlet.closable !== false)
                    .map((dashlet) => (React.createElement(DashletToggle, { t: t, key: dashlet.title, dashlet: dashlet, enabled: getSafe(dashletSettings, [dashlet.title, "enabled"], true), onToggle: onSetDashletEnabled }))))));
    }
}
function mapStateToProps(state) {
    return {
        dashletSettings: state.settings.interface.dashletSettings,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onSetDashletEnabled: (dashletId, enabled) => dispatch(setDashletEnabled(dashletId, enabled)),
    };
}
export default translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(Settings));
